import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import auth from '../../firebase.init';
import useAdmin from '../../hooks/useAdmin';
import Swal from 'sweetalert2';

const SinglePart = ({part}) => {

  const {_id,name,img,description,price,minimumorderquantity,availablequantity} = part;
  const [user]=useAuthState(auth)
const[admin]=useAdmin(user)
   const navigate =useNavigate();
   const NavigaetPurchase =(_id)=>{
      console.log(admin)
    if(admin===true){
           
      Swal.fire({
        title: `You Are Admin`,
      
        icon: 'error',
        showConfirmButton:false,

        timer: 2500
    });
    }
      else{
        navigate(`/purchase/${_id}`)
      }
   }


  return (
         <div> 
          
<div className="card  h-[525px] relative lg:max-w-lg  bg-base-100 shadow-xl">
  <figure class="px-10 pt-10 h-48">
    <img loading='lazy'  className='md:w-48 md:h-48 md:rounded-none rounded-full mx-auto'src={img} alt="part"/>
  </figure>
  <div className="card-body items-center text-center">
    <h2 className="card-title">{name}</h2>
    <p>{description}</p>
    <p className='text-[16px] font-medium' >Price ${price}</p>
    <p>Minimum order quantity:{minimumorderquantity}</p>
    <p>Available quantity:{availablequantity}</p>
    <div className=" absolute bottom-0 w-full ">
      <button onClick={()=>NavigaetPurchase(_id)} class="border  py-2 border-t-0  border-b rounded-b-[10px] btn btn-secondary w-full text-white  rounded-none  bg-gradient-to-r from-secondary to-primary">Buy Now</button>
    </div>
    {/* card-actions */}
  </div>
</div>









        </div> 
     )
};

export default SinglePart;